var $948d43a8543e5720$exports = {};
// WTF 09.06 JSON
const $948d43a8543e5720$var$myObject1 = {
    name: "Paweł",
    hi: ()=>{
        console.log("hi");
    },
    age: 37,
    hobby: [
        "frontend",
        "music",
        "gaming"
    ]
};
console.log($948d43a8543e5720$var$myObject1);
$948d43a8543e5720$var$myObject1.hi;
console.log(JSON.stringify($948d43a8543e5720$var$myObject1));
const $948d43a8543e5720$var$myJSON = JSON.stringify($948d43a8543e5720$var$myObject1);
console.log(typeof $948d43a8543e5720$var$myJSON);
const $948d43a8543e5720$var$myParsedObject = JSON.parse($948d43a8543e5720$var$myJSON);
console.log($948d43a8543e5720$var$myParsedObject);


//# sourceMappingURL=index.d9f8e7b3.js.map
